<div class="device-access-request mt-5">
    <header>
        <img src="/assets/img/brand/mymeds-logo-full.svg" alt="MyMedsPH Logo" class="logo mb-3">
    </header>
    <section class="content mt-5">
        <div class="icon-container mb-4">
            <mat-icon class="info-icon">devices_other</mat-icon>
        </div>
        <h2 class="m-3">Device Access Request</h2>
        <div class="message-box mb-4 mt-3">
            <h3 class="message">
                You are logging in from an <strong class="highlight">unregistered device</strong>.
                For security, your account owner must <strong class="highlight">approve this device</strong> before you can continue.
            </h3>
        </div>
        <h4 class="instructions mb-4">
            Give this device a <strong>clear, recognizable label</strong> — such as <em>"Front Desk PC"</em> or <em>"Dr. John Doe's Laptop"</em>.
            A descriptive name helps your account owner quickly identify and approve the right device.
        </h4>

        <form [formGroup]="requestForm" (ngSubmit)="onSubmit()" class="mt-4">
            <div class="form-group mb-4">
                <label for="deviceLabel" class="form-label">Device Label</label>
                <input
                    type="text"
                    id="deviceLabel"
                    class="form-control"
                    formControlName="label"
                    placeholder="e.g., My Work Laptop, Office Desktop"
                    [class.is-invalid]="requestForm.get('label')?.invalid && requestForm.get('label')?.touched"
                />
                <div class="invalid-feedback" *ngIf="requestForm.get('label')?.invalid && requestForm.get('label')?.touched">
                    <span *ngIf="requestForm.get('label')?.errors?.['required']">Device label is required.</span>
                    <span *ngIf="requestForm.get('label')?.errors?.['maxlength']">Device label must be less than 255 characters.</span>
                </div>
            </div>

            <div class="alert alert-danger" *ngIf="submitError">
                {{ submitError }}
            </div>

            <div class="alert alert-success" *ngIf="submitSuccess">
                Device access request submitted successfully! Redirecting to login...
            </div>

            <div class="row justify-content-center mt-4">
                <div class="col-12 col-sm-6 col-md-3 mb-3">
                    <button
                        type="submit"
                        class="btn btn-raised btn-primary w-100 hover-btn"
                        [disabled]="requestForm.invalid || isSubmitting"
                    >
                        <mat-icon *ngIf="!isSubmitting">send</mat-icon>
                        <span *ngIf="isSubmitting">Submitting...</span>
                        <span *ngIf="!isSubmitting">Submit Request</span>
                    </button>
                </div>
                <div class="col-12 col-sm-6 col-md-3 mb-3">
                    <button
                        type="button"
                        class="btn btn-raised btn-secondary w-100 hover-btn"
                        (click)="goToLogin()"
                        [disabled]="isSubmitting"
                    >
                        <mat-icon>login</mat-icon>
                        Back to Login
                    </button>
                </div>
            </div>
        </form>
    </section>
</div>
<footer>
    <p>
        <a href="https://mymedsph.com/">MyMedsPH</a> &nbsp;&nbsp;&nbsp;&nbsp; 0917 705 7827
        &nbsp;&nbsp;&nbsp;&nbsp; info@mymedsph.com
    </p>
</footer>
